/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import BreadcrumbLabel from "./BreadcrumbLabel";
import { DashboardExploreObject } from "components/DashboardRoute";

type ExploreObject = Pick<
  DashboardExploreObject,
  "region" | "district" | "store" | "id" | "name" | "firstName" | "lastName"
>;

interface BreadcrumbProps {
  category: string;
  exploreObject: ExploreObject;
  url: string;
}

export default function Breadcrumb({
  category,
  exploreObject,
  url,
}: BreadcrumbProps) {
  return (
    <View
      style={{
        flexDirection: "row",
        paddingHorizontal: 10,
        paddingVertical: 1,
        borderBottomRightRadius: 5,
      }}
    >
      <BreadcrumbLabel
        isFirst={true}
        grouping={null}
        groupingObject={null}
        isLast={!category || category === "organization"}
        url={url}
      />
      {exploreObject.region || category === "region" ? (
        <BreadcrumbLabel
          grouping={"region"}
          groupingObject={
            exploreObject.region ? exploreObject.region : exploreObject
          }
          isFirst={false}
          isLast={category === "region"}
          url={url}
        />
      ) : null}
      {exploreObject.district || category === "district" ? (
        <BreadcrumbLabel
          grouping={"district"}
          groupingObject={
            exploreObject.district ? exploreObject.district : exploreObject
          }
          isFirst={false}
          isLast={category === "district"}
          url={url}
        />
      ) : null}
      {exploreObject.store || category === "store" ? (
        <BreadcrumbLabel
          grouping={"store"}
          groupingObject={
            exploreObject.store ? exploreObject.store : exploreObject
          }
          isFirst={false}
          isLast={category === "store"}
          url={url}
        />
      ) : null}
      {category === "user" ? (
        <BreadcrumbLabel
          grouping={"user"}
          groupingObject={exploreObject}
          isFirst={false}
          isLast={true}
          url={url}
        />
      ) : null}
    </View>
  );
}
